module.exports = {"371472100":"赵虎镇","371472101":"抬头寺镇","371472400":"新区服务管理办公室"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371472.json
// module id = 1600
// module chunks = 0